// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__CV3GL","info":"UpdateTermsInfo_info__3JhA7"};